import { generateClient } from 'aws-amplify/api';
import { ulid } from 'ulid';
import { CONSTANTS, REVISION } from '../game';
import { Schema } from '../../../amplify/data/resource';
import packageJson from '../../../package.json';
import { SessionManager } from './SessionManager';

const client = generateClient<Schema>();

/**
 * プレイ開始時間のログを記録するクラス
 * 各プレイの開始時間、シード値、ゲームバージョンを記録し、30日間保持します
 */
export class PlayLogger {
  /**
   * プレイ開始時間を記録する
   * @param {string} seed ゲームのシード値
   * @returns {Promise<string|null>} 成功時はプレイID、失敗時はnull
   */
  static async logPlayStart(seed: string): Promise<string | null> {
    try {
      const playerId = (await SessionManager.getOrCreateSession()).playerId;
      if (!playerId) {
        console.error('No player ID found, cannot log play start');
        return null;
      }
      
      const playId = ulid();
      const now = new Date();
      const ttl = Math.floor(now.getTime() / 1000) + (30 * 24 * 60 * 60); // 30日後
      
      // PlayStartLogレコードを作成
      await client.models.PlayStartLog.create({
        playerId,
        playId,
        startTime: now.toISOString(),
        seed,
        version: packageJson.version, // package.jsonからバージョン情報を取得
        revision: REVISION, // game.jsからインポートしたリビジョン情報
        ttl
      }, {
        authMode: 'identityPool'
      });
      
      console.log('プレイ開始ログを記録しました。ID:', playId);
      return playId;
    } catch (error) {
      console.error('プレイ開始ログの記録に失敗しました:', error);
      // エラー時もゲームは続行できるようにする
      return null;
    }
  }
}
